import { createPortal } from "react-dom";
import "./CreateFieldModal.css";

const CreateFieldModal = ({
  show, onClose, onCreate,
  newFieldName, setNewFieldName,
  newFieldType, setNewFieldType
}) => {
  if (!show) return null;

  return createPortal(
    <div className="create-field-overlay" onClick={onClose}>
      <div className="create-field-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>Create New Field</h3>
        <label className="modal-field-label">Field Name</label>
        <input
          type="text"
          placeholder="Field name"
          value={newFieldName}
          onChange={(e) => setNewFieldName(e.target.value)}
          autoFocus
        />
        <label className="modal-field-label">Field Type</label>
        <select value={newFieldType} onChange={(e) => setNewFieldType(e.target.value)}>
          <option value="str">Single Line Text</option>
          <option value="list">Multi-Select List</option>
        </select>
        <div className="modal-buttons">
          <button type="button" onClick={onCreate} className="create-button">Add Field</button>
          <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreateFieldModal;
